import $ from 'jquery';
import Swiper from 'swiper/bundle';

// Export Recently Viewed
export default () => {
  // Recently Viewed Products
  const productJson = JSON.parse(
    document.querySelector('[data-product-json]').innerHTML,
  );

  const nextProduct = document.querySelector(
    '.swiper-button-next--product-recent',
  );
  const prevProduct = document.querySelector(
    '.swiper-button-next--product-recent',
  );

  let storedProducts = JSON.parse(
    window.localStorage.getItem('storedProducts'),
  );

  const target = `#recently-viewed-products`;

  const rvContainer = document.getElementById('recently-viewed-products');
  const rvCarousel = document.querySelector('.recently-viewed__carousel');
  const rvDots = rvCarousel.querySelector('.swiper-pagination');

  let slideCount = 0;
  if (storedProducts == null) {
    slideCount = 0;
  } else {
    slideCount = storedProducts.length - 1;
  }

  // console.log(`Total Slides: ${slideCount}`);

  let spv = 1;
  let tabspv = 1;
  let mobspv = 1;
  if (slideCount === 0) {
    rvCarousel.classList.add('hide-arrows');
    rvContainer.classList.add('c-slide');
    rvDots.classList.add('hide-dots');
  } else if (slideCount === 1) {
    spv = 1;
    tabspv = 1;
    mobspv = 1;
    rvCarousel.classList.add('hide-arrows');
    rvContainer.classList.add('c-slide');
    rvDots.classList.add('hide-dots');
  } else if (slideCount === 2) {
    spv = 2;
    tabspv = 2;
    mobspv = 2;
    rvCarousel.classList.add('hide-arrows-d');
    rvContainer.classList.add('c-slide');
  } else if (slideCount === 3) {
    spv = 3;
    tabspv = 3;
    mobspv = 2;
    rvCarousel.classList.add('hide-arrows-d');
    rvContainer.classList.add('c-slide');
  } else if (slideCount === 4) {
    rvCarousel.classList.add('hide-arrows-d');
  } else {
    spv = 4;
    tabspv = 3;
    mobspv = 2;
  }

  // console.log(spv);

  const rvSwiper = new Swiper(target, {
    observer: true,
    observeParents: true,
    freeMode: false,
    centerInsufficientSlides: true,
    pagination: {
      el: '.swiper-pagination--product-recent',
      dynamicBullets: true,
    },
    navigation: {
      nextEl: '.swiper-button-next--product-recent',
      prevEl: '.swiper-button-prev--product-recent',
    },
    breakpoints: {
      480: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        pagination: {
          dynamicMainBullets: 3,
        },
      },
      720: {
        slidesPerView: mobspv,
      },
      767: {
        slidesPerView: 3,
        pagination: {
          dynamicMainBullets: 4,
        },
      },
      1023: {
        slidesPerView: 4,
        pagination: {
          dynamicMainBullets: 5,
        },
      },
      1280: {
        slidesPerView: 'auto',
        // slidesPerGroup: spv,
        pagination: {
          dynamicMainBullets: 6,
        },
      },
    },
  });

  function addProductEntry() {
    if (storedProducts === null) {
      storedProducts = [];
    }

    const currentProductID = productJson.id;
    const currentProductHandle = productJson.handle;
    const product = {
      handle: currentProductHandle,
      id: currentProductID,
    };

    if (
      JSON.parse(window.localStorage.getItem('product')) !==
      currentProductHandle
    ) {
      window.localStorage.setItem('product', JSON.stringify(product));
    }

    let productExists = false;
    for (let i = storedProducts.length; i--; ) {
      const curProduct = storedProducts[i];

      if (curProduct.handle === product.handle) {
        productExists = true;
        break;
      }
    }
    if (!productExists) {
      storedProducts.push(product);
    }
    if (window.localStorage.getItem(storedProducts)) {
      window.localStorage.getItem(
        'storedProducts',
        JSON.stringify(storedProducts),
      );
    } else {
      window.localStorage.setItem(
        'storedProducts',
        JSON.stringify(storedProducts),
      );
    }

    // if (storedProducts.length < 5 && nextProduct) {
    //   nextProduct.style.display = "none";
    //   prevProduct.style.display = "none";
    // }
  }

  const savedProductsArr = JSON.parse(
    window.localStorage.getItem('storedProducts'),
  );

  if (savedProductsArr === null) {
    const elem = document.querySelector(
      '#shopify-section-recently-viewed-products',
    );
    elem.parentNode.removeChild(elem);
  } else {
    const savedProductsArrReverse = savedProductsArr;

    // if (savedProductsArrReverse.length < 5 && nextProduct) {
    //   nextProduct.style.display = "none";
    //   prevProduct.style.display = "none";
    // }

    savedProductsArrReverse.forEach((product) => {
      getStoredProducts(product);
      // console.log(product);
    });
  }

  function getStoredProducts(product) {
    // console.log(`/products/${product.handle}?view=accentuate.json`);

    $.ajax({
      type: 'GET',
      dataType: 'html',
      url: `/products/${product.handle}?view=accentuate.json`,
      success(productData) {
        const html = $.parseHTML(productData);
        const body = $(html).text();
        const json = $.parseJSON(body);

        // console.log(json);

        const context = {
          title: json.title,
          url: json.url,
          image: json.isolate_image,
          type: json.type,
        };

        const rvProducts = storedProducts.length;
        const rvActive = rvProducts >= 4;
        const rvHideShow = rvActive ? 'show-recent' : 'hide-recent';
        const rv = document.getElementById('rec-view');
        rv.classList.add(rvHideShow);
        // console.log(`Product Count: ${rvProducts}`);
        // console.log(`Total Product: ${rvProducts}`);
        // console.log(`More than 4: ${rvActive}`);
        // console.log(rvHideShow);

        const template = `
        <div class="swiper-slide">
          <a href="${context.url}" class="collection-grid-item__image-wrapper">
            <img src="${context.image}" alt="${context.title}" class="collection-grid-item__no-hover" />
          </a>
          <div class="collection-grid-item__text-wrapper">
            <p><a href="${context.url}" class="button">See this ${context.type}</a></p>
          </div>
        </div>`;

        // $(template).appendTo('#recently-viewed');
        rvSwiper.appendSlide(template);

        window.setTimeout(() => {
          rvSwiper.slideTo(0);
        }, 500);
      },
      error(productData) {
        // window.console.dir(productData);
      },
    });

    // List of all entries
    // console.log(localStorage.getItem('storedProducts'));

    // Last entry inserted
    // console.log(localStorage.getItem('product'));
  }

  function init() {
    addProductEntry();
  }

  /**
   * Return immutable object.
   */
  return Object.freeze({
    init,
  });
};
